import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../lib/auth";

/**
 * CustomerRoute — guard for /portal/*.
 *
 * Only customer principals may pass. Anonymous → /login. Internal users
 * (admin/employee) are redirected to their dashboard so nobody lands on
 * a portal that carries the wrong permissions.
 */
export default function CustomerRoute({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return <div className="min-h-screen flex items-center justify-center text-zinc-500">Lade…</div>;
  }
  if (!user) return <Navigate to="/login" replace />;
  if (user.principal_type !== "customer") return <Navigate to="/" replace />;
  return children;
}
